import React, {useEffect, useState} from "react";
import "./App.css";
import {BrowserRouter as Router, Route, Routes, Navigate} from "react-router-dom";
import MainPage from "./pages/MainPage";
import PricePage from "./pages/PricePage";
import FaqPage from "./pages/FaqPage";
import ApplyPage from "./pages/ApplyPage";
import AdminPage from "./pages/AdminPage";
import AdminInquiryPage from "./pages/AdminInquiryPage";
import {auth} from "./firebase";
import {onAuthStateChanged} from "firebase/auth";
import {AdminProvider} from "./utils/AdminContext";
import RedirectionPage from "./pages/RedirectionPage";
import InstructorPage from "./pages/InstructorPage";

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthenticated(!!user);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AdminProvider>
      <Router>
        <Routes>
          <Route path="/" element={<MainPage/>}/>
          <Route path="/apply" element={<ApplyPage/>}/>
          <Route path="/price" element={<PricePage/>}/>
          <Route path="/faq" element={<FaqPage/>}/>
          <Route path="/admin" element={<AdminPage/>}/>
          <Route path="/instructor" element={<InstructorPage />}/>
          <Route
            path="/admin/inquiry"
            element={
              authenticated ? <AdminInquiryPage/> : <Navigate to="/admin"/>
            }
          />
          <Route path={'*'} element={<RedirectionPage />}/>
        </Routes>
      </Router>
    </AdminProvider>
  );
}

export default App;
